import { useForm } from 'react-hook-form'
import { userSchema } from '../../utils/entities'
import { UserType } from '../../utils/types'
import { zodResolver } from '@hookform/resolvers/zod'
import { usePassword } from '../usePassword'
import { useTaxID } from '../useTaxID'

export const useUserForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    getValues,
    setError,
    watch,
  } = useForm<UserType>({ resolver: zodResolver(userSchema) })
  const { validatePassword } = usePassword()
  const { validateTaxID } = useTaxID()

  const validateAdditionalData = (data: UserType) => {
    let isValid = true
    const validation = validatePassword(data.password)

    if (!validation.isValid) {
      setError('password', {
        type: 'validate',
        message: 'A senha não está de acordo com as regras necessárias',
      })

      isValid = false
    }

    if (!validateTaxID(data.cpf)) {
      setError('cpf', {
        type: 'validate',
        message: 'CPF inválido',
      })

      isValid = false
    }

    return isValid
  }

  const onSubmit = (callback: (data: UserType) => void) => {
    return handleSubmit((data) => {
      if (!validateAdditionalData(data)) return

      callback(data)
    })
  }

  return {
    register,
    handleSubmit: onSubmit,
    errors,
    clearErrors,
    setValue,
    getValues,
    setError,
    watch,
  }
}
